// extracted by css-extract-rspack-plugin
export default {"section":"Form__section--lukhS"};